import React, { FC } from 'react'
import styled from 'styled-components'
import tailwind from 'src/helpers/tailwind'

const StyledGrid = styled.div`
  @media (min-width: ${tailwind.theme.screens.md}) {
    > :nth-child(4n + 1),
    > :nth-child(4n + 2) {
      grid-column: 1;
    }
  }
  @media (min-width: ${tailwind.theme.screens.lg}) {
    > :nth-child(8n + 1),
    > :nth-child(8n + 2) {
      grid-column: 1;
    }
    > :nth-child(8n + 3),
    > :nth-child(8n + 4) {
      grid-column: 2;
    }
    > :nth-child(8n + 5),
    > :nth-child(8n + 6) {
      grid-column: 3;
    }
  }
`

interface IFourHeadedItemsGrid {
  className?: string
  children: JSX.Element[]
}

const FourHeadedItemsGrid: FC<IFourHeadedItemsGrid> = ({
  children,
  className,
}) => {
  const getMdCols = () =>
    children.length > 2 ? 'md:grid-cols-2' : 'md:grid-cols-none'
  const getLgCols = () =>
    children.length > 6 ? 'lg:grid-cols-4' : 'lg:grid-cols-none'
  return (
    <StyledGrid
      className={`grid grid-cols-1 grid-flow-row-dense ${getMdCols()} ${getLgCols()} ${className}`}
    >
      {children}
    </StyledGrid>
  )
}

FourHeadedItemsGrid.defaultProps = {
  className: '',
}

export default FourHeadedItemsGrid
